import { render, staticRenderFns } from "./OSMMapLoader.vue?vue&type=template&id=5751b479"
import script from "./OSMMapLoader.vue?vue&type=script&lang=js"
export * from "./OSMMapLoader.vue?vue&type=script&lang=js"
import style0 from "./OSMMapLoader.vue?vue&type=style&index=0&id=5751b479&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports